export default function pagination(renderOptions) {
  const {
    isFirstPage,
    isLastPage,
    createURL,
    currentRefinement,
    nbPages,
    widgetParams,
  } = renderOptions;

  const container = document.querySelector(widgetParams.container);

  if (nbPages === 1) {
    container.innerHTML = '';
    container.classList.add('no-pagination');
    return;
  } else {
    container.classList.remove('no-pagination');
  }
  const previous = isFirstPage
    ? `<span class="pagination__next-prev-button disabled">Previous</span>`
    : `<a href="${createURL(
      currentRefinement - 1,
    )}" class="pagination__next-prev-button" aria-label="Previous Page" data-value="${currentRefinement -
        1}">Previous</a>`;

  const next = isLastPage
    ? `<span class="pagination__next-prev-button disabled">Next</span>`
    : `<a href="${createURL(
      currentRefinement + 1,
    )}" class="pagination__next-prev-button" aria-label="Next Page" data-value="${currentRefinement +
        1}">Next</a>`;

  container.innerHTML = `
    <ul class="pagination__list">
      <li class="pagination__list-item pagination__title">
        <span class="pagination__title__text pagination__title__text--current">${currentRefinement +
          1}</span>
        <span class="pagination__title__text pagination__title__text--slash">/</span>
        <span class="pagination__title__text pagination__title__text--current">${nbPages}
      </li>
      <li class="pagination__next-prev previousPage">${previous}</li>
      <li class="pagination__next-prev nextPage">${next}</li>
    </ul>
  `;
}
